import { render, staticRenderFns } from "./CatalogInstance.vue?vue&type=template&id=450dc5f1&scoped=true"
import script from "./CatalogInstance.vue?vue&type=script&lang=ts"
export * from "./CatalogInstance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450dc5f1",
  null
  
)

export default component.exports